import {
  SET_TRAINING_RECORDINGS,
  SET_TRAINING_RECORDINGS_LOADING,
  SET_TRAINING_RECORDINGS_ERROR,
  PATCH_TRAINING_RECORDING,
  REMOVE_TRAINING_RECORDING
} from '../actions/recordings.actions';

const initialState = {
  trainingId: null,
  clusterId: null,
  recordings: [],
  loading: false,
  error: null
};

const recordingsReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_TRAINING_RECORDINGS:
      return {
        ...state,
        trainingId: action.payload.trainingId || null,
        clusterId: action.payload.clusterId || null,
        recordings: action.payload.recordings,
        error: null
      };
    case SET_TRAINING_RECORDINGS_LOADING:
      return { ...state, loading: action.payload };
    case SET_TRAINING_RECORDINGS_ERROR:
      return { ...state, error: action.payload };
    case PATCH_TRAINING_RECORDING: {
      const updated = action.payload;
      if (!updated || !updated.id) return state;
      return {
        ...state,
        recordings: state.recordings.map((r) => (r.id === updated.id ? { ...r, ...updated } : r))
      };
    }
    case REMOVE_TRAINING_RECORDING:
      return {
        ...state,
        recordings: state.recordings.filter((r) => r.id !== action.payload)
      };
    default:
      return state;
  }
};

export default recordingsReducer;
